<div class="filters">
  <div class="bg-white p-2">

    <div class="form-row col-lg-12 bg-white p-2">
      <div class="col-lg-3">
        <label>Ospite</label>
        <input class="form-control " (ngModelChange)="onInput($event)" type="text" placeholder="Scrivi un Ospite"
          [(ngModel)]="filtro.ospite">
      </div>
      <div class="col-lg-3">
        <label>Inizio</label>
        <input class="form-control" (ngModelChange)="onInput($event)" type="date" [(ngModel)]="filtro.inizio">
      </div>
      <div class="col-lg-3">
        <label>Fine</label>
        <input class="form-control" (ngModelChange)="onInput($event)" type="date" [(ngModel)]="filtro.fine">
      </div>

    </div>
  </div>
  <div *ngIf="Clienti && Presenze">
    <app-dynamic-col-table [(columns)]="Presenze" [(rows)]="Clienti" [hasSave]="true" (onSaveClick)="UpdatePresenze()"
      [hasNote]="true" [notePlaceholder]="'Note Obbligatorie se Alvo non regolare'"
      [CampiColonne]="[{nome: 'Temperatura',  param:0}, {nome: 'Pressione',  param:1},  {nome: 'Glicemia',  param:2}, {nome: 'Diuresi',  param:3}, {nome: 'Alvo',  param: 4, type:'dropdown', source: [{id: 'Regolare', label: 'Regolare'}, {id: 'Non Regolare', label: 'Non Regolare'}]}]"></app-dynamic-col-table>
  </div>